import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { errMsg, get, put } from "@/lib/api";

export function SourceToggle() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["live-provider"], queryFn: () => get("/live/provider"), refetchInterval: 30000 });
  const save = useMutation({
    mutationFn: (body) => put("/live/provider", body),
    onSuccess: (r, body) => {
      qc.setQueryData(["live-provider"], r);
      ["live-status", "live-vessels", "live-coverage", "live-ports", "live-track"].forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
      const label = r.providers.find((p) => p.id === r.active)?.label;
      toast.success(body.active ? `Live AIS source: ${label}` : `Datalastic area: ${r.areas.find((a) => a.id === r.datalastic_area)?.label}`);
    },
    onError: (e) => toast.error("Could not change source", { description: errMsg(e) }),
  });
  if (!data) return null;
  return (
    <div className="flex items-center gap-2" data-testid="source-toggle">
      <div className="inline-flex rounded-full border border-white/10 bg-black/30 p-0.5">
        {data.providers.map((p) => (
          <button key={p.id} data-testid={`source-${p.id.toLowerCase()}`} disabled={!p.configured || save.isPending} onClick={() => p.id !== data.active && save.mutate({ active: p.id })}
            className={`rounded-full px-3 py-1 font-mono text-[11px] uppercase tracking-wider transition-colors disabled:opacity-40 ${data.active === p.id ? "bg-lime-400 text-slate-950" : "text-slate-300 hover:text-white"}`}>
            {p.label}
          </button>
        ))}
      </div>
      {data.active === "DATALASTIC" && (
        <select data-testid="datalastic-area-select" value={data.datalastic_area} disabled={save.isPending} onChange={(e) => save.mutate({ datalastic_area: e.target.value })} className="h-8 rounded border border-[#1E3E30] bg-[#0C1B15] px-2 text-xs text-slate-200">
          {data.areas.map((a) => <option key={a.id} value={a.id}>{a.label}</option>)}
        </select>
      )}
    </div>
  );
}
